const TWITTER_ICON = require('images/live/twitter.svg')
const LINKEDIN_ICON = require('images/live/linkedin.svg')

const Social = ({ handle, type, className }) => {
  let primaryEl = null

  const style = `social-content ${className}`
  if (type === "linkedin") {
    const linkedin = `https://linkedin.com/${handle}`
    primaryEl = (<a href={linkedin} className="social-primary-social"><img src={LINKEDIN_ICON}/></a>)

  } else if (type === "twitter") {
    const twitterUrl = `https://twitter.com/${handle}`
    primaryEl = (<a href={twitterUrl} className="social-primary-social"><img src={TWITTER_ICON}/></a>)
  }

  return (
    <span className={style}>
      {primaryEl}
    </span>
  )
}


export default Social



// WEBPACK FOOTER //
// ./src/scripts/components/shared/ContactRecordLite/Social/index.js